import routes from "./../router/routes";
export default {
  install(Vue) {
    const commonRoutePath = {
      400: "/bad-request",
      403: "/access-denied",
      404: "/not-found",
      408: "/request-timeout"
    };

    const getPathList = () => {
      let pathList = [];

      routes.map(route => {
        if (route.path) {
          route.path[route.path.length - 1] == "*"
            ? pathList.push(route.path.slice(0, -1).toLowerCase())
            : pathList.push(route.path.toLowerCase());
        }
      });

      return pathList;
    };

    const pageNotFoundHandler = (to, from, next) => {
      if (!to.matched.length) {
        let routePaths = getPathList();

        if (!routePaths.includes(to.path.toLowerCase())) next("/not-found");
        else next();
      } else {
        next();
      }
    };

    Vue.prototype.$commonRoute = {
      path: commonRoutePath,
      pageNotFoundHandler
    };
  }
};
